<hr />
<footer>
    <div class="center boxed section-spacing">
        <div class="px-7">
            <div class="columns">
                <div class="left pr-16">
                    <img class="w-52" src="assets/logos/mailfox.svg" alt="{{ 'labels_mailfox' | translate }}" />
                    <p class="block">
                        {{ 'labels_footer_description' | translate }}
                    </p>
                </div>
                <div class="left">
                    <p class="leadtext no-margin">{{ 'labels_support' | translate }}</p>

                    <a class="block text-primary mt-3 hover:text-black" href="mailto:support@mailfox.dev" title="Email"
                        >support&commat;mailfox.dev</a
                    >
                    <a
                        class="block text-primary hover:text-black"
                        [href]="environment.websiteUrl + '#pricing'"
                        title="Pricing"
                        >{{ 'labels_pricing' | translate }}</a
                    >
                </div>
                <div class="left">
                    <p class="leadtext no-margin">{{ 'labels_guides' | translate }}</p>

                    @if (items | async; as providers) {
                        @for (provider of providers; let i = $index; track provider) {
                            @if (i < 4) {
                                <a
                                    [href]="environment.websiteUrl + '/guides/' + provider.slug"
                                    class="block text-primary hover:text-black"
                                    [ngClass]="{ 'mt-3': i === 0 }"
                                    [title]="provider.title"
                                    target="_blank">
                                    {{ provider.title }}
                                </a>
                            }
                        }
                    }
                </div>
                <div class="left">
                    <div class="sm:mt-10 -mt-8"></div>

                    @if (items | async; as providers) {
                        @for (provider of providers; let i = $index; track provider) {
                            @if (i >= 4) {
                                <a
                                    [href]="environment.websiteUrl + '/guides/' + provider.slug"
                                    class="block text-primary hover:text-black"
                                    [title]="provider.title"
                                    target="_blank">
                                    {{ provider.title }}
                                </a>
                            }
                        }
                    }
                </div>

                <div class="left">
                    <p class="leadtext no-margin">{{ 'labels_legal' | translate }}</p>
                    <a
                        [href]="environment.websiteUrl + '/imprint/'"
                        title="{{ 'labels_imprint' | translate }}"
                        class="block text-primary mt-3 hover:text-black"
                        >{{ 'labels_imprint' | translate }}</a
                    >
                    <a
                        [href]="environment.websiteUrl + '/privacy/'"
                        title="
                        {{ 'labels_privacy' | translate }}"
                        class="block text-primary hover:text-black"
                        >{{ 'labels_privacy' | translate }}</a
                    >
                    <a
                        [href]="environment.websiteUrl + '/tos/'"
                        title="
                        {{ 'labels_terms_of_use' | translate }}"
                        class="block text-primary hover:text-black"
                        >{{ 'labels_terms_of_use' | translate }}</a
                    >
                </div>
            </div>
        </div>
        <div class="flex gap-5 items-center mt-14 px-7">
            <img
                width="80"
                height="80"
                class="rounded-full"
                src="assets/images/christofer-huber.jpg"
                alt="{{ 'labels_christofer_huber' | translate }}" />
            <div>
                <p class="no-margin left leadtext">{{ 'labels_hey_guys' | translate }}</p>
                <p class="left no-margin">
                    {{ 'labels_iam' | translate }}
                    <a
                        class="text-primary hover:text-black"
                        href="https://christofer-huber.com/"
                        title="{{ 'labels_christofer_huber' | translate }}"
                        >{{ 'labels_christofer' | translate }}</a
                    >{{ 'labels_creator_of_mailfox' | translate }}
                    <a class="text-primary hover:text-black" href="https://x.com/crebuh" title="X">{{
                        'labels_follow_x' | translate
                    }}</a>
                </p>
            </div>
        </div>
    </div>
    <div class="p-3 bg-slate-500">
        <div class="center boxed">
            <div class="flex justify-between flex-wrap">
                <small class="text-white block text-center md:text-left">{{
                    'labels_footer_copyright' | translate: { year }
                }}</small>
                <small class="text-white block text-center md:text-end">v {{ version }}</small>
            </div>
        </div>
    </div>
</footer>
